export const PUBLIC_ROUTES = {
  LANDING: "/",
  LOGIN: "/login",
  LOGIN_PHONE: "/login/phone",
  REGISTER: "/register",
  OVERVIEW: "/overview",
  FORGOT_PASSWORD: "/forgot",
  RESET_PASSWORD: "/reset/:token",
  PRICING: "/pricing",
  ACCEPT_INVITE: "/invite/:token",
  PUBLIC_MICROSITE: "/share/:slug",
  SHORT_LINK: "/u/:code",
} as const;

export const PROTECTED_ROUTES = {
  DASHBOARD: "/dashboard",
  ARCHIVED_DEALS: "/archived",
  DEAL_DETAIL: "/deals/:id",
  DEAL_SUMMARY_PRINT: "/deals/:id/summary/print",
  INVITES: "/invites",
  BILLING: "/o/:slug/billing",
  REPORTS: "/reports",
  HELP: "/help",
} as const;

export const SHARED_PROTECTED_ROUTES = {
  AUDIT: "/audit",
  NOTIFICATIONS: "/notifications",
  SETTINGS: "/settings",
  /** Deals this account was invited into. Shared, because an internal user can
   *  hold a participation on another brokerage's deal — their membership must
   *  not be what hides it from them. */
  SHARED_WITH_ME: "/shared",
  /** Every invited deal's conversations in one place — the portal sidebar's Chats. */
  CHATS: "/chats",
} as const;

export const EXTERNAL_ROUTES = {
  CLIENT_DEAL: "/me/deal/:id",
  COLLAB_DEAL: "/collab/deal/:id",
} as const;

export const buildResetPasswordPath = (token: string) => `/reset/${token}`;
export const buildAcceptInvitePath = (token: string) => `/invite/${token}`;
export const buildPublicMicrositePath = (slug: string) => `/share/${slug}`;
export const buildDealDetailPath = (id: string) => `/deals/${id}`;
export const buildDealSummaryPrintPath = (id: string) => `/deals/${id}/summary/print`;
export const buildBillingPath = (slug: string) => `/o/${slug}/billing`;
export const buildClientDealPath = (id: string) => `/me/deal/${id}`;
export const buildCollabDealPath = (id: string) => `/collab/deal/${id}`;
